import { RiArrowLeftSLine } from '@remixicon/react'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
    title?: string
    children?: ReactNode
    showGoBack?: boolean
}

export default function HeaderPageSection({
    title,
    children,
    showGoBack = true,
}: Props) {
    const router = useNavigate()
    return (
        <div
            className={`w-full h-20 flex items-center ${
                title !== undefined ? 'justify-between' : 'justify-end'
            } mt-10`}
        >
            {title !== undefined && (
                <div className="text-[#070A13] text-[32px] font-semibold flex items-center gap-4">
                    {showGoBack && (
                        <button
                            onClick={() => router(-1)}
                            className="text-gray-500 hover:text-gray-700 transition-colors"
                            aria-label="Cerrar"
                        >
                            <RiArrowLeftSLine size={24} />
                        </button>
                    )}
                    <h1>{title}</h1>
                </div>
            )}
            <div>{children}</div>
        </div>
    )
}
